import styles from "styles/Footer.module.scss";
import GetIcon from "components/GetIcon";

const Footer = () => {
    return (
        <footer className={styles.footer}>
            <div className={styles.footerContent}>
                <p>
                    <GetIcon icon="CgGym" size={30} color="white" /> <span>Muscle Factory S.A</span>
                </p>
                <div className={styles.contactInfoHorizontal}>
                    <p className={styles.contactPhone}>Teléfono: <a href="tel:+50685975180">+506 8597-5180</a></p>
                    <div className={styles.socialLinksHorizontal}>
                        <a href="https://www.facebook.com/musclefactorycr" target="_blank" rel="noopener noreferrer"
                           style={{paddingRight: "15px"}}>
                            <GetIcon icon="BsFacebook" size={20} color="white"/> Facebook
                        </a>
                        <a href="https://www.instagram.com/muscle_factory_gym_cr/" target="_blank"
                           rel="noopener noreferrer">
                            <GetIcon icon="BsInstagram" size={20} color="white"/> Instagram
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;